/* ============
 * Account Index Page
 * ============
 *
 * Page where the user can view the account information
 */
import api from './../../services/api';
import authService from './../../services/auth';
import AButton from '../../components/button/button.vue';
import Vue from 'vue';

export default {
  components: {
    AButton
  },
  data() {
    return {
      credentials: {
        email: '',
        password: '',
      }
    }
  },
  computed: {
    locality() {
      return localStorage.getItem('codigoPais');
    },
  },
  mounted() {
    this.ipInfo();
  },
  methods: {
    back() {
      Vue.router.go(-1);
    },
    async ipInfo() {
      const rs = await api.get('https://ipinfo.io');
      if (rs.status === 200) {
          this.credentials.operador = rs.data.org;
          this.credentials.imei = `00000000-0000-0000-0000-0000${navigator.productSub}`;
          this.credentials.versionso = navigator.appVersion;
          this.credentials.versionapp = navigator.appVersion;
          this.credentials.modelo = navigator.product;
          this.credentials.marca = navigator.appName;
      }
    },
    doLogin(data, channel) {
      console.log('datalogin',data, channel)
      authService.login(data, channel, 'home');
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/signin/index.js